<template>
  <div class="container o-form-page">
    <o-working-overlay :working="working"></o-working-overlay>

    <o-section :title="title" @click="enableDebug($event)" :level="0">
      <item-form :form-state="formState" :item="item" :server-errors="serverErrors"></item-form>
    </o-section>

    <o-action-buttons :item="item" :form-state="formState" :create="create" @save="doSave"
      @saveAndClose="doSaveAndClose" @saveAndNew="doSaveAndNew" @delete="doDeleteItem" :show-create-and-new="true">
    </o-action-buttons>
  </div>
</template>

<script>
import { CreateFormPageMixin, CreateGroupPermissionMixin, UnsavedMixin } from '../../../vue-ocom/mixins'
import ItemForm from '../components/ItemForm.vue'
import OActionButtons from "../../../vue-ocom/components/forms/OActionButtons";
import OSection from "../../../vue-ocom/components/layout/OSection";
import OWorkingOverlay from "../../../vue-ocom/components/OWorkingOverlay";

export default {
  mixins: [UnsavedMixin, CreateFormPageMixin('TermsAndCondition', 'terms_and_condition'), CreateGroupPermissionMixin('TermsAndCondition')],
  components: {
    OSection,
    OWorkingOverlay,
    OActionButtons,
    ItemForm,
  },
  computed: {
    title() {
      if (this.create) {
        return "Create Terms and Condition";
      }

      return "Edit Terms and Condition"
    }
  }
}
</script>